import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Post } from '@getaccept/dsr-shared-new';
import { FeedConstants } from '@getaccept/dsr-shared-new/src/feed/constants/feed.constants';
import { PostService } from '../../../api/posts/post.service';

export const usePublishedFeedStore = defineStore('publishedFeed', () => {
  const posts = ref<Post[]>([]);
  const loadingPosts = ref(false);

  const load = async () => {
    if (posts.value.length % 10) {
      return;
    }

    loadingPosts.value = true;
    try {
      const loadedPosts = await PostService.load({
        ...FeedConstants.defaultPayload,
        offset: posts.value.length,
      });
      posts.value = posts.value.length === 0 ? loadedPosts : [...posts.value, ...loadedPosts];
    } catch (error) {
      console.error(error);
    } finally {
      loadingPosts.value = false;
    }
  };

  const setPostSeen = async (postId: string, participantId: string) => {
    try {
      await PostService.setSeenBy(postId);
      posts.value = posts.value.map(post => {
        if (post.id === postId) {
          return {
            ...post,
            seenBy: [...post.seenBy, participantId],
          };
        }
        return post;
      });
    } catch (error) {
      console.error(error);
    }
  };

  const init = () => {
    posts.value = [];
  };

  return {
    posts,
    loadingPosts,
    setPostSeen,

    load,
    init,
  };
});
